module.exports = __webpack_public_path__ + "img/jhonn-vesga.f23ea334.webp";